<span
  class="np-informer-trigger"
  [class.np-informer-trigger--open]="informerOpen"
  (click)="op.toggle($event)"
  [pTooltip]="header"
  tooltipPosition="top"
  tooltipStyleClass="p-n-tooltip px-2"
  [showDelay]="200"
  [life]="1000">
  <i
    *ngIf="unreadCount <= 0"
    class="pi {{ icon }} p-text-secondary">
  </i>
  <i
    *ngIf="unreadCount > 0"
    class="pi {{ icon }} p-text-secondary"
    pBadge
    severity="danger"
    [value]="unreadCount > 99 ? '99+' : unreadCount.toString()">
  </i>
</span>

<p-overlayPanel
  #op
  [style]="{ width: 'min(400px, calc(100vw - 24px))' }"
  styleClass="dropdown-overlay-panel informer-overlay-panel-v2"
  (onShow)="onInformerShow()"
  (onHide)="onInformerHide()">
  <ng-template pTemplate="">
    <div class="inf-v2">
      <div class="inf-v2-head">
        <div class="inf-v2-head__left">
          <span
            class="inf-v2-head__accent"
            aria-hidden="true"></span>
          <crm-button
            type="button"
            icon="pi pi-refresh"
            styleClass="p-button-rounded text-white p-button-text mx-1"
            (onClick)="queryParams.offset = 0; loadNotifications()"></crm-button>
          <p class="inf-v2-head__title">{{ header }}</p>
        </div>
        <div class="flex align-items-center gap-1 flex-shrink-0">
          <crm-button
            *ngIf="globalService.globalInfo.tenantInfo.subdomain !== 'mvideo.zafrm.pro'"
            label="Подробнее"
            icon="pi pi-window-maximize"
            styleClass="text-white p-button-text"
            (onClick)="op.hide()"
            routerLink="/notification/activity"
            [queryParams]="
              { kind: informerType, statuses: [NotificationTargetStatusEnum.SENT] } | concatDateParams: 'month'
            "></crm-button>
          <crm-button
            *ngIf="globalService.globalInfo.tenantInfo.subdomain === 'mvideo.zafrm.pro'"
            label="Подробнее"
            icon="pi pi-window-maximize"
            styleClass="text-white p-button-text"></crm-button>
        </div>
      </div>

      <div
        class="inf-v2-scroll"
        (scroll)="onScrollEnd($any($event.target))">
        <div *ngIf="loading" class="inf-v2-loading-fill">
          <crm-spinner></crm-spinner>
        </div>
        <ng-container *ngIf="!loading">
          <div
            *ngFor="let notification of notifications | orderBy: '-created:date'"
            class="inf-v2-card">
            <div class="flex">
              <div class="p-3">
                <crm-user-avatar
                  *ngIf="notification.lastNotification?.user"
                  [user]="{
                    id: notification.lastNotification.user?.id,
                    profile: notification.lastNotification.user?.profile
                  }"></crm-user-avatar>
                <crm-user-avatar
                  *ngIf="notification.lastNotification?.externalUser"
                  [user]="{
                    id: notification.lastNotification.externalUser?.id,
                    profile: notification.lastNotification.externalUser?.profile
                  }"></crm-user-avatar>
                <crm-user-avatar
                  *ngIf="!notification.lastNotification?.user && !notification.lastNotification?.externalUser"
                  [user]="{
                    id: -1,
                    profile: {
                      id: '00000000-0000-0000-0000-000000000000',
                      name: 'Сервисное Уведомление',
                      file: null
                    }
                  }"></crm-user-avatar>
              </div>
              <div class="py-3 pr-3 pb-2 w-full">
                <div class="flex justify-content-between">
                  <div>
                    <p class="font-bold">
                      {{
                        notification?.lastNotification?.user?.profile?.name ||
                          notification?.lastNotification?.externalUser?.profile?.name ||
                          'Сервисное уведомление'
                      }}
                    </p>
                    <p class="text-400 text-sm">
                      {{ notification.lastNotification?.created | date: 'dd.MM.yyyy HH:mm' }}
                    </p>
                  </div>
                  <p-tag
                    *ngIf="notification?.notificationIds?.length > 1"
                    [value]="notification?.notificationIds?.length?.toString()"
                    styleClass="mr-2"
                    [rounded]="true"></p-tag>
                </div>
                <p
                  *ngIf="notification.lastNotification?.subject?.title !== 'Сервисное уведомление'"
                  class="font-medium mb-1 mt-3">
                  {{ notification.lastNotification?.subject?.title }}
                </p>
                <p
                  class="break-word"
                  [class.mt-3]="notification.lastNotification?.subject?.title === 'Сервисное уведомление'"
                  style="max-height: 200px; overflow: hidden"
                  [innerHTML]="notification.lastNotification?.text | truncate: 150 | safeHtml"></p>
                <div
                  *ngIf="notification.lastNotification?.files?.length"
                  class="flex flex-column gap-2 mt-2">
                  <crm-document-link
                    *ngFor="let file of notification.lastNotification.files"
                    class="w-full"
                    containerClass="w-full"
                    [fileNameLength]="0"
                    [file]="file"></crm-document-link>
                </div>
                <div class="flex mt-2">
                  <crm-button
                    *ngIf="notification.lastNotification?.subject?.link"
                    label="Перейти"
                    [icon]="'pi pi-reply'"
                    (onClick)="read(notification); openNotificationCard(notification); op.hide()"
                    styleClass="p-button-secondary p-button-text p-button-sm"></crm-button>
                  <crm-button
                    label="Прочитать"
                    [icon]="'pi pi-eye'"
                    styleClass="p-button-secondary p-button-text p-button-sm ml-2"
                    (onClick)="read(notification)"></crm-button>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="paginationLoading"
            class="text-center py-3">
            <p-progressSpinner
              [style]="{
                width: '50px',
                height: '50px'
              }"></p-progressSpinner>
          </div>

          <div
            *ngIf="!notifications?.length"
            class="inf-v2-empty">
            <crm-no-data [size]="NoDataSize"></crm-no-data>
            <h4 class="font-normal">
              {{
                unreadCount === 0
                  ? 'Нет новых уведомлений'
                  : 'Обновите список, для просмотра непрочитанных уведомлений'
              }}
            </h4>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
